import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-white text-noche" data-id="element-85" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-xl px-3 py-4 sm:px-5" data-id="element-86" data-mp="9u37w1zr0c5x">
        <Reveal className="flex items-start gap-3 rounded-2xl border-2 border-verde bg-verde/10 p-3 text-left" data-id="element-87" data-mp="9wpe9yawklmk">
          <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full border-2 border-oro bg-verde" data-id="element-88" data-mp="jssh76dkwoak">
            <ShieldCheckIcon size={24} className="text-white" data-id="element-89" data-mp="nt2nkk5a9gpy" />
          </span>
          <div data-id="element-90" data-mp="skccfij0cg0s">
            <p className="font-sub text-xs font-extrabold uppercase tracking-wide text-noche/80" data-id="element-91" data-mp="slvr54p0mj0g">
              Tu inversión está protegida
            </p>
            <h2 id="garantia" className="font-display text-2xl uppercase leading-tight tracking-wide sm:text-3xl" data-id="element-92" data-mp="xls07ickl0mv">
              🛡️ Garantía total de 7 días
            </h2>
            <p className="mt-0.5 text-xs leading-snug text-noche/80 sm:text-sm" data-id="element-93" data-mp="25rnkn44bquve">
              Tienes 7 días para explorar los 6 tomos y los 5 bonos. Si
              consideras que el sistema no es adecuado para ti, puedes
              solicitar un reembolso dentro del período establecido según los
              términos de devolución.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}